import { Link } from 'react-router-dom'
import { ArrowTopRightOnSquareIcon, BuildingOffice2Icon } from '@heroicons/react/24/outline'

const getPlacowkaId = value => {
	if (!value) return null
	if (typeof value === 'object') return value?._id || value?.id || null
	return value
}

export default function OsobaPlacowkaCard({ placowka }) {
	const placowkaId = getPlacowkaId(placowka)
	const nazwa = placowka?.nazwa || '-'

	return (
		<li className="col-span-1">
			<div className="flex h-[440px] w-full flex-col overflow-hidden rounded-md border border-slate-200 bg-gradient-to-b from-slate-50 to-white shadow-sm">
				<div className="flex flex-shrink-0 flex-row gap-3 border-b border-slate-300 bg-gray-100 px-6 py-3 sm:items-center sm:justify-between">
					<div className="flex items-start gap-3">
						<div className="flex flex-col gap-1">
							<h3 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
								<BuildingOffice2Icon className="h-5 w-5 text-sky-700" />
								<span>Placowka</span>
							</h3>
						</div>
					</div>
					<div className="ml-auto flex items-center gap-4">
						{placowkaId ? (
							<Link
								to={`/klienci/placowki/details/${placowkaId}`}
								className="inline-flex items-center gap-2 text-sm text-sky-700 hover:text-sky-800">
								<ArrowTopRightOnSquareIcon className="h-5 w-5" />
								<span>Przejdz do szczegolow</span>
							</Link>
						) : null}
					</div>
				</div>

				<div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 pb-4 pt-4 sm:px-6 sm:pb-6">
					{!placowkaId ? (
						<div className="flex flex-1 items-center justify-center gap-3 rounded-md bg-white px-4 text-sm text-slate-600">
							<BuildingOffice2Icon className="h-5 w-5 text-slate-400" />
							<span>Brak przypisanej placowki.</span>
						</div>
					) : (
						<div className="rounded-md border border-slate-200 bg-white px-4 py-4 shadow-sm">
							<p className="text-base font-semibold text-slate-900">{nazwa}</p>
							<p className="mt-1 text-sm text-slate-600">{placowka?.adres || '-'}</p>
							<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-slate-100 pt-4 text-sm sm:grid-cols-2">
								<div>
									<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Miasto</dt>
									<dd className="mt-0.5 text-slate-900">{placowka?.id_miasto?.nazwa || '-'}</dd>
								</div>
								<div>
									<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Gmina</dt>
									<dd className="mt-0.5 text-slate-900">{placowka?.id_gmina?.nazwa || '-'}</dd>
								</div>
								<div>
									<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Powiat</dt>
									<dd className="mt-0.5 text-slate-900">{placowka?.id_powiat?.nazwa || '-'}</dd>
								</div>
								<div>
									<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Wojewodztwo</dt>
									<dd className="mt-0.5 text-slate-900">{placowka?.id_wojewodztwo?.nazwa || '-'}</dd>
								</div>
								<div className="sm:col-span-2">
									<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Typ</dt>
									<dd className="mt-0.5 text-slate-900">{placowka?.id_typ?.typ || '-'}</dd>
								</div>
							</dl>
						</div>
					)}
				</div>
			</div>
		</li>
	)
}
